import { useCallback } from 'react';
import { scoreWord } from '../utils/api';

export function useScoring(puzzle) {
  const score = useCallback(
    async (word, rowAdj, colAdj) => {
      const result = await scoreWord(word, rowAdj, colAdj, puzzle.date);
      return result;
    },
    [puzzle.date]
  );

  return { score };
}
